import { Component, HostBinding, OnInit, OnDestroy, SimpleChanges, SimpleChange, Input } from '@angular/core';
import { ConsumerService } from '../../../services/consumer.service';
import { ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';
import { ConsumerDetailInjector } from '../consumer-detail-injector';
import { ConsumerInteractionService } from '../../../services/consumer-interaction.service';
import { DeviceType } from '../../../models/consumer/consumer-bulk-interaction.model';
import { getInteractionType } from '../../../utilities/consumer-utilities';
import { ConsumerInteractionProgressType, ConsumerInteractionType, ConsumerInteractionModel } from '../../../models/consumer/consumer-interaction.model';

@Component({
    selector: 'meter-consumption-item',
    templateUrl: './meter-consumption-item.component.html',
})


export class MeterConsumptionItemComponent implements OnInit, OnDestroy {

    @HostBinding('class.two-thirds') isTwoThirds: boolean = false;
    @HostBinding('class.third') isThird: boolean = true;
    issues: any[] = [];
    consumerId: string;
    subscriptions: any[] = [];
    latestMeterReads: any[] = [];
    MeterReadsSVGModel: any[] = [];
    MeterReads: any[] = [];
    MeterReads2: any[] = [];
    clientId: number;
    expandVisible: boolean = true;
    hasData: boolean = false;
    hasLoading: boolean = true;
    showProgress: boolean = false;
    consumerHasBilling: boolean;
    consumerHasPayg: boolean;
    consumerIntervalId: any;
    isProcessing: boolean = false;
    intervalList: any[] = [];
    progress: ConsumerInteractionProgressType = ConsumerInteractionProgressType.InProgress;
    interactionType: ConsumerInteractionType = ConsumerInteractionType.GetMeterRead;

    constructor(
        private consumerService: ConsumerService,
        private route: ActivatedRoute,
        consumerDetailInjector: ConsumerDetailInjector,
        private consumerInteractionService: ConsumerInteractionService) {
        this.issues = consumerDetailInjector.issues;
        this.consumerHasBilling = consumerDetailInjector.consumerHasBilling;
        this.consumerHasPayg = consumerDetailInjector.consumerHasPayg;
    }

    onInfoClick() {
        swal({
            title: 'Meter read & consumption',
            html: '<p style="text-align: left;">This widget shows the latest meter reading information per active meter.</p>\
             <p style="text-align: left;">On expansion of the widget, the consumption history is shown for each of the supply meters.</p>',
            confirmButtonText: 'Close',
            confirmButtonColor: '#00539f'
        });
    }

    ngOnInit() {

        //this.consumerHasPayg = (this.consumer.consumerType === 'PAYG') ? true : false;
        //this.consumerHasBilling = (this.consumer.consumerType === 'Billing') ? true : false;

        this.latestMeterReads.push(this.MeterReads);
        this.latestMeterReads.push(this.MeterReads2);

        this.clientId = this.route.parent.snapshot.params['clientId'];
        this.subscriptions.push(this.route
            .params
            .subscribe(params => {
                this.consumerId = params['consumerId'];
            }));

        this.consumerService.getLatestMeterReads(this.clientId, this.consumerId).then((latestRes) => {
            if (latestRes) {
                this.latestMeterReads = [];

                if (latestRes.length > 4) {
                    this.MeterReads = latestRes.slice(0, 4);
                    this.MeterReads2 = latestRes.slice(4, latestRes.length);
                    this.latestMeterReads.push(this.MeterReads);
                    this.latestMeterReads.push(this.MeterReads2);
                } else {
                    this.latestMeterReads.push(latestRes);
                    this.latestMeterReads.push(this.MeterReads2);
                }

                latestRes.length > 4 ? (this.isTwoThirds = true, this.isThird = false) : (this.isTwoThirds = false, this.isThird = true);
            }
        })

        if (this.consumerHasPayg && !this.consumerHasBilling) {
            this.consumerInteractionService.GetConsumerInteraction(this.clientId, this.consumerId, this.interactionType).then((interactionRes) => {
                let interaction = interactionRes as ConsumerInteractionModel[];
                if (!interaction) {
                    this.showProgress = false;

                } else {
                    this.progress = getInteractionType(interaction);
                    this.progress == ConsumerInteractionProgressType.InProgress ? this.showProgress = true : this.showProgress = false;
                    if (this.progress == ConsumerInteractionProgressType.InProgress) {
                        this.getMeterInteraction();
                    }
                }

            }).catch((error) => {
                this.progress = ConsumerInteractionProgressType.Error;
                this.showProgress = false;
            })
        }
    }

    ngOnDestroy() {
        this.clearIntervalList();
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    setExpandVisable(isVisible: boolean) {
        this.expandVisible = isVisible;
    }

    getMeterInteraction() {
        if (this.progress != ConsumerInteractionProgressType.InProgress && this.consumerHasPayg) {
            this.clearIntervalList();
            this.pollMeterInteractionStatus();
        }

       this.intervalList.push(window.setInterval(() => { this.pollMeterInteractionStatus() }, 30000));
    }

    clearIntervalList() {
        for (let i = 0; i < this.intervalList.length; i++) {
            window.clearInterval(this.intervalList[i]);
        }

        for (let j = 0; j < 100; j++) {
            window.clearInterval(j);
        }

        this.intervalList = [];
    }

    pollMeterInteractionStatus() {
        if (this.latestMeterReads && this.consumerHasPayg) {
            let promises: Promise<any>[] = [];
            if (this.progress != ConsumerInteractionProgressType.InProgress) {
                this.isProcessing = true;
                if (this.latestMeterReads.find(x => x.supplyName == "Heat")) {
                    promises.push(this.consumerInteractionService.PostDeviceMeterRead(this.clientId, this.consumerId, DeviceType.Heat));
                }

                if (this.latestMeterReads.find(x => x.supplyName == "Electricity")) {
                    promises.push(this.consumerInteractionService.PostDeviceMeterRead(this.clientId, this.consumerId, DeviceType.Electricity));
                }

                if (this.latestMeterReads.find(x => x.supplyName != "Electricity" && x.supplyName != "Heat")) {
                    promises.push(this.consumerInteractionService.PostDeviceMeterRead(this.clientId, this.consumerId, DeviceType.Other));
                }

                Promise.all(promises).then(
                    results => {
                        this.consumerInteractionService.GetConsumerInteraction(this.clientId, this.consumerId, this.interactionType).then((interactionRes) => {
                            let interaction = interactionRes as ConsumerInteractionModel[];
                            if (!interaction) {
                                this.showProgress = false;
                                this.isProcessing = false;

                            } else {
                                this.showProgress = true;
                                this.isProcessing = false;
                                this.progress = getInteractionType(interaction);
                                if (this.progress == ConsumerInteractionProgressType.Completed || this.progress == ConsumerInteractionProgressType.Error) {
                                    this.clearIntervalList();
                                }
                            }

                        }).catch((error) => {
                            this.progress = ConsumerInteractionProgressType.Error;
                            this.showProgress = false;
                            this.isProcessing = false;
                        })
                    },
                    errors => {
                        this.progress = ConsumerInteractionProgressType.Error;
                        this.showProgress = false;
                        this.isProcessing = false;
                    }
                )
            } else {
                if (this.consumerHasPayg) {
                    this.consumerInteractionService.GetConsumerInteraction(this.clientId, this.consumerId, this.interactionType).then((interactionRes) => {
                        let interaction = interactionRes as ConsumerInteractionModel[];
                        if (!interaction) {
                            this.showProgress = false;
                            this.isProcessing = false;
                        } else {
                            this.showProgress = true;
                            this.isProcessing = false;
                            this.progress = getInteractionType(interaction);
                            if (this.progress == ConsumerInteractionProgressType.Completed || this.progress == ConsumerInteractionProgressType.Error) {
                                this.clearIntervalList();
                            }
                        }

                    }).catch((error) => {
                        this.progress = ConsumerInteractionProgressType.Error;
                        this.showProgress = false;
                        this.isProcessing = false;
                    })
                }
            }
        }
    }
}
